import Model from 'flarum/common/Model';

export default class FreeResource extends Model {
  id = Model.attribute('id');
  title = Model.attribute('title');
  description = Model.attribute('description');
  thumbnail = Model.attribute('thumbnail');
  file_path = Model.attribute('file_path');
  type = Model.attribute('type');
  created_at = Model.attribute('created_at');
  updated_at = Model.attribute('updated_at');

  apiEndpoint() {
    return '/free-resources' + (this.exists ? '/' + this.data.id : '');
  }
}
